var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5714 9.46429H12.8125V6.96429C12.8125 6.17523 12.173 5.53572 11.3839 5.53572H8.61605C7.82699 5.53572 7.18748 6.17523 7.18748 6.96429V9.46429H6.42855C6.23101 9.46429 6.07141 9.62389 6.07141 9.82143V14.1071C6.07141 14.3047 6.23101 14.4643 6.42855 14.4643H13.5714C13.769 14.4643 13.9286 14.3047 13.9286 14.1071V9.82143C13.9286 9.62389 13.769 9.46429 13.5714 9.46429ZM10.3125 12.1094V12.7009C10.3125 12.75 10.2723 12.7902 10.2232 12.7902H9.77677C9.72766 12.7902 9.68748 12.75 9.68748 12.7009V12.1094C9.59535 12.0432 9.52659 11.9496 9.49109 11.8419C9.45558 11.7341 9.45517 11.6179 9.48992 11.51C9.52466 11.402 9.59276 11.3079 9.68442 11.2411C9.77608 11.1743 9.88657 11.1383 9.99998 11.1383C10.1134 11.1383 10.2239 11.1743 10.3155 11.2411C10.4072 11.3079 10.4753 11.402 10.51 11.51C10.5448 11.6179 10.5444 11.7341 10.5089 11.8419C10.4734 11.9496 10.4046 12.0432 10.3125 12.1094ZM12.0089 9.46429H7.99105V6.96429C7.99105 6.61943 8.27119 6.33929 8.61605 6.33929H11.3839C11.7288 6.33929 12.0089 6.61943 12.0089 6.96429V9.46429Z",
    fill: "#3A3A3A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    stroke: "#3A3A3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.382470475e2c01fe96fb4b5ec9e13fa6.svg";
export { ForwardRef as ReactComponent };